import styled from 'styled-components';

export const StyledUserActivityItem = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 24px 0;

  & + & {
    border-top: 1px solid #ccc;
  }

  > * + * {
    padding-left: 24px;
  }
`;

export const UserActivityAvatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  text-transform: uppercase;
  color: #fff;
  font-size: 20px;
  align-self: flex-start;
`;

export const UserActivityItemContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const UserActivityItemTitle = styled.h3`
  font-size: 16px;
  margin: 0;
  font-weight: 600;
  color: #444;
`;

export const UserActivityItemMessage = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: #444;
  margin: 0;
`;

export const UserActivityComments = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: #444;
  margin: 0;
`;

export const UserActivityItemTime = styled.div`
  font-size: 16px;
  text-align: right;
  color: #767676;
`;
